Dom.addComponent(new class TooltipComponent extends AbstractComponent {

  constructor() {
    super({
      name: "tooltip",
      iframable: true,
      responsiveChildren: {
        width: false,
        height: true
      }
    });
  }

  css() {
    return `GULP-CSS-FILE-TOOLTIP`;
  }

  html(props) {
    return `
      <div class="slaask-hidden">
        <div class="slaask-tooltip-wrapper">
          <div id="slaask-tooltip-right-arrow-inner" class="slaask-tooltip-right-arrow-inner slaask-hidden">
            <span></span>
          </div>
          <div id="slaask-tooltip-bottom-arrow-inner" class="slaask-tooltip-bottom-arrow-inner slaask-hidden">
            <span></span>
          </div>
          <div class="slaask-tooltip-container">
            <div id="slaask-tooltip-header-cross" class="slaask-tooltip-header-cross">${Svg.cross('#d3d3d3', 12)}</div>
            <div id="slaask-tooltip-title" class="slaask-tooltip-title"></div>
            <div id="slaask-tooltip-content" class="slaask-tooltip-content"></div>
            <div class="slaask-tooltip-powered-by">${this.app._whitelabel_html}</div>
          </div>
          <div id="slaask-tooltip-top-arrow-inner" class="slaask-tooltip-top-arrow-inner slaask-hidden">
            <span></span>
          </div>
          <div id="slaask-tooltip-left-arrow-inner" class="slaask-tooltip-left-arrow-inner slaask-hidden">
            <span></span>
          </div>
        </div>
      </div>
    `;
  }

});
